import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { ReceiptApiAdapter } from '../adapters/ReceiptApiAdapter';

export interface ReceiptCart {
    id: number;
    code: string;
    total_products: number;
    total_quantity: number;
    has_dispatch: boolean;
    dispatch_type: 'LOCATION_ORDER' | 'EXTRA_WORK_ORDER' | null;
    dispatch_id: number | null;
}

export interface ReceiptCartsResponse {
    data: ReceiptCart[];
}

export const useReceiptCarts = (
    entryId: number,
    receiptId: number,
    enabled: boolean = true
) => {
    const httpClient = createHttpClient(apiClientWH);
    const receiptAdapter = new ReceiptApiAdapter(httpClient);

    return useQuery<ReceiptCartsResponse, Error>({
        queryKey: ['entry-receipt-carts', entryId, receiptId],
        queryFn: () => receiptAdapter.getCarts(entryId, receiptId),
        enabled: entryId > 0 && receiptId > 0 && enabled,
        staleTime: 30 * 1000, // Los datos son frescos por 30 segundos
    });
};

